import React from 'react';
import { IconButton } from '../../../icon-button';
import { Icon } from '../../../icon';
export const ErrorActionButtons = ({ file, onAttach, onRemoveFile, errorCode }) => {
    const { uploadStatus } = file;
    return (React.createElement(React.Fragment, null,
        uploadStatus === 'error' && errorCode === 'network-error' ? (React.createElement(IconButton, { onClick: () => onAttach === null || onAttach === void 0 ? void 0 : onAttach([file]), "data-testid": "reload-on-error-button" },
            React.createElement(Icon, { name: "replay" }))) : null,
        React.createElement(IconButton, { onClick: () => onRemoveFile === null || onRemoveFile === void 0 ? void 0 : onRemoveFile(file), "data-testid": "remove-on-error-button" },
            React.createElement(Icon, { name: "close" }))));
};
